// Single source of truth for "is this session allowed to send analytics".
//
// Only production sessions belonging to real users may send events. "Real user"
// excludes impersonated sessions and internal account types — see `isRealUser`
// in src/ThirdPartyProviders/ThirdPartyProvider.tsx, which is the only place
// with the auth/preferences context needed to decide this.
//
// The gate is a module-level value because PostHog is itself a
// module-level singleton: the app sets it once, and every trackEvent() call
// reads it at call time rather than at render time. It lives in
// packages/shared so that src/ and packages/manual-ticket consumers all share
// one gate.
//
// Defaults to false so that any consumer which never opts in sends nothing —
// tests and Storybook, for example. (The MSEM sub-app has no analytics wiring
// at all: it never renders ThirdPartyProvider, so it neither sets this gate nor
// mounts the click tracker.)
let analyticsEnabled = false;

export const setAnalyticsEnabled = (enabled: boolean): void => {
  analyticsEnabled = enabled;
};

export const isAnalyticsEnabled = (): boolean => analyticsEnabled;
